/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { UserJoinLoyaltyCreateStatus200, UserJoinLoyaltyCreateStatus401, UserJoinLoyaltyCreateStatus503 } from "../types/UserJoinLoyaltyCreate.ts";

function getUserJoinLoyaltyCreateUrl() {
	const res = { method: "POST", url: `/api/user/join-loyalty/` as const };

	return res;
}

/**
 * @description Присоединение к программе лояльности.
 * @summary присоединение к лояльности
 * {@link /api/user/join-loyalty/}
 */
export async function userJoinLoyaltyCreate(config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<UserJoinLoyaltyCreateStatus200, ResponseErrorConfig<UserJoinLoyaltyCreateStatus401 | UserJoinLoyaltyCreateStatus503>, unknown>({
		method: "POST",
		url: getUserJoinLoyaltyCreateUrl().url.toString(),
		...requestConfig,
	});

	return res.data;
}
